import React from 'react';
import { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import SiteAdmin from '../components/SiteAdmin';
import Page from '../../../components/Page';
import Container from '@material-ui/core/Container';
import { BillingAPI } from '../../../api';
import Loader from '../../../components/Loader';
import DataTable from '../components/DataTable';
import { prettyLocalDate } from '../../../lib/time';
import { formatCurrency } from '../../../lib/currency';
import withAdminOnly from '../components/AdminOnly';
import Dialog from '@material-ui/core/Dialog';
import {default as StdButton} from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '../../../components/Button';
import Alert from '@material-ui/lab/Alert';

const useStyles = makeStyles({
  alert: {
    marginBottom: '1rem',
  },
});

// REVISIT:
// This implementation would be improved if it used a custom table/grid layout instead
// of the data-table.  Then we could add a retry button within the row to make the
// retry action more obvious.   - GC Feb 2021

const makeRow = (overdue) => [
  prettyLocalDate(overdue.transaction.declined_at),
  overdue.provider_name,
  formatCurrency(overdue.transaction.amount),
  overdue.transaction.cardholder_name,
  overdue.transaction.card_type + ' ending in ' + overdue.transaction.last4,
  overdue.transaction.expiration_date,
  overdue.transaction.processor_response_text,
];


const headers = [
  'Date',
  'Provider',
  'Amount',
  'Cardholder',
  'Card',
  'Expiry',
  'Reason',
];

const BillingAdminPage = () => {
  const [overdueList, setOverdueList] = useState();
  const [busy, setBusy] = useState(false);
  const [selected, setSelected] = useState(undefined);
  const [success, setSuccess] = useState(undefined);
  const [message, setMessage] = useState(undefined);
  const classes = useStyles();

  const onClick = (row, index) => {
    setSelected(overdueList[index]);
  };

  const closeDialog = () => setSelected(undefined);

  const statusMessage = () => {
    if (success === undefined) return null;
    return (
      <Alert
        className={classes.alert}
        onClose={()=>setSuccess(undefined)}
        severity={success ? 'success' : 'error'}
      >
        {message}
      </Alert>
    );
  };

  const loadOverdue = async () => {
    const result = await BillingAPI.getOverdueSubscriptions();
    setOverdueList(result.payload.overdue);
  };

  const retryTransaction = async () => {
    setBusy(true);
    setSuccess(undefined);
    try {
      const { payload } = await BillingAPI.retrySubscriptionPayment(selected.subscription.id);
      setSuccess(payload.success);
      setMessage(payload.success ? 'Retry succeeded' : payload.message);
      setSelected(undefined);
    } catch {
      setSuccess(false);
      setMessage('Retry failed');
    } finally {
      setBusy(false);
      loadOverdue();
    }
  };

  useEffect(() => {
    loadOverdue();
  }, []);  // eslint-disable-line

  return (
    <Page title="Billing Overdue Reports">
      <SiteAdmin>
        <Container>
          {statusMessage()}
          {overdueList ?
            (
              overdueList.length ?
                <DataTable
                  headers={headers}
                  rows={Object.values(overdueList).map(makeRow)}
                  onClick={onClick}
                />
                :
                <Alert severity="info">No overdue subscriptions.</Alert>
            )
            :
            <Loader/>
          }
        </Container>
      </SiteAdmin>
      {selected &&
        <Dialog open={true} onClose={closeDialog} aria-labelledby="retry-dialog-title">
          <DialogTitle id="retry-dialog-title">Retry Transaction</DialogTitle>
          <DialogContent>
            <DialogContentText>{formatCurrency(selected.transaction.amount) + ' for ' + selected.provider_name}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <StdButton onClick={closeDialog} color="primary">
              Cancel
            </StdButton>
            <Button onClick={retryTransaction} variant="contained" label="Retry" color="primary" busy={busy}/>
          </DialogActions>
        </Dialog>
      }
    </Page>
  );
};

export default withAdminOnly(BillingAdminPage);
